import 'react-vertical-timeline-component/style.min.css';
import { useState, useEffect } from 'react'
import { LinearProgress } from '@mui/material';
import config from '../config.json';
import { VerticalTimelineTemplate } from '../customComponents/VerticalTimelineTemplate';


export default function Demo() {

    const userData = {
        // userID: parseInt(localStorage.getItem("userID")),
        show: false,
    };

    const [allPrograms, setAllPrograms] = useState([]);
    const [isLoading, setisLoading] = useState(true);
    const [start, setStart] = useState()
    const [end, setEnd] = useState()
    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });
    const { mobileView } = state;
    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 900
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };
        let endPoint = `/api/programs/list/view`
        //process.env.REACT_APP_API_URL
        fetch(process.env.REACT_APP_API_URL + endPoint, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then((res) => res.json())
            .then((data) => {
                let resp = data.response.response_data
                let newArray = resp.slice(0, resp.length - 1)

                setAllPrograms(newArray)
                setStart(resp[resp.length - 1].start.slice(0, 4))
                setEnd(resp[resp.length - 1].end.slice(0, 4))
                setisLoading(false);
            }).catch(err => {
                //console.log(err)
            });
        setResponsiveness();
        window.addEventListener('resize', () => setResponsiveness());

        return () => {
            window.removeEventListener('resize', () => setResponsiveness());
        };
        // eslint-disable-next-line
    }, [])

    const DisplayDesktop = () => {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", paddingTop: '20px' }}>
                    <span style={{
                        height: "100px",
                        width: "100px",
                        "backgroundColor": config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
                        "borderRadius": "50%",
                        display: "inline-block",
                        "fontWeight": '500',
                        color: 'white'

                    }}>
                        <div style={{ display: "flex", justifyContent: "center", paddingTop: '25%', fontSize: '2rem' }}>
                            {start}
                        </div>
                    </span>
                </div>

                <VerticalTimelineTemplate dataArray={allPrograms} userData={userData} />



                <div style={{ display: "flex", justifyContent: "center" }}>
                    <span style={{
                        height: "100px",
                        width: "100px",
                        "background-color": config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
                        "border-radius": "50%",
                        display: "inline-block",
                        "font-weight": '500',
                        color: 'white'

                    }}>
                        <div style={{ display: "flex", justifyContent: "center", paddingTop: '25%', fontSize: '2rem' }}>
                            {end}
                        </div>
                    </span>
                </div>
            </div>
        );
    }
    const displayMobile = () => {
        return (
            <div>
                <div style={{ paddingLeft: '3px', paddingTop: '20px' }}>
                    <span style={{
                        height: "55px",
                        width: "55px",
                        "backgroundColor": config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
                        "borderRadius": "50%",
                        display: "inline-block",
                        "fontWeight": '500',
                        color: 'white'

                    }}>
                        <div style={{ display: "flex", justifyContent: "center", paddingTop: '25%', fontSize: '1.4rem' }}>
                            {start}
                        </div>
                    </span>
                </div>

                <VerticalTimelineTemplate dataArray={allPrograms} userData={userData} />

                <div style={{ paddingLeft: '3px' }}>
                    <span style={{
                        height: "55px",
                        width: "55px",
                        "backgroundColor": config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
                        "borderRadius": "50%",
                        display: "inline-block",
                        "fontWeight": '500',
                        color: 'white'

                    }}>
                        <div style={{ display: "flex", justifyContent: "center", paddingTop: '25%', fontSize: '1.4rem' }}>
                            {end}
                        </div>
                    </span>
                </div>
            </div >
        );
    }
    if (!isLoading) {
        return <div>{mobileView ? displayMobile() : DisplayDesktop()}</div>;

    } else {
        return (
            <div style={{ marginTop: 20, textAlign: 'center' }}>
                <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
                <LinearProgress />
            </div>
        );
    }

}
